import { Map, List } from 'immutable'

/**
 * Thunk decorator for thunks that return promises.
 *
 * It takes a thunk and returns a thunk that memoizes the returned promise until it resolves.
 * The main advantage of this is that other thunks can call thunks they depend on without need
 * for explicit coordination.
 *
 * This is particularly useful for idempotent actions (e.g. join conversation, fetch a token, etc).
 */

let _promiseMap = Map()

const memoize = (thunk) => (...args) => (dispatch) => {
  const key = List([thunk, ...args])

  const existingPromise = _promiseMap.get(key)
  if (existingPromise) {
    return existingPromise
  }

  const promise = dispatch(thunk(...args))
  _promiseMap = _promiseMap.set(key, promise)

  promise.then(() => {
    _promiseMap = _promiseMap.delete(key)
  }).catch(() => {
    _promiseMap = _promiseMap.delete(key)
  })

  return promise
}

export default memoize



// WEBPACK FOOTER //
// ./src/scripts/app/api/memoize.js